import { useTranslation } from 'next-i18next';
import React from 'react';

import { JOURNAL_PAGE_TYPE } from '../../../constants';
import { useProducts } from '../../../hooks/useProducts';
import { getArtistTileOverline } from '../../../utils/artists';
import { shopifyAdminIdToGraphqlId } from '../../../utils/shopifyIds';
import ArtistTile from '../ArtistTile';
import { StoryDetailsProduct } from './index';

interface Props {
  details: DetailsType;
}

export const StoryDetails: React.FC<Props> = ({
  details: { artists = [], heading, products = [] },
}) => {
  const { t } = useTranslation();

  const { products: shopifyProducts } = useProducts(getProductIds(products));

  return (
    <aside>
      {heading && <h3 className="font-bold">{heading}</h3>}
      {artists.map((artist) => (
        <div key={artist.uuid} className="mt-2">
          <ArtistTile
            artist={{
              name: artist.name,
              slug: artist.full_slug,
              thumbnail: artist.content?.thumbnail,
            }}
            overline={getArtistTileOverline(
              artist.content.totalWorks || 0,
              artist.content.hideCollaborations || false,
              t,
            )}
            page={JOURNAL_PAGE_TYPE}
          />
        </div>
      ))}
      {shopifyProducts.map((product) => (
        <div key={product.id} className="mt-2">
          <StoryDetailsProduct product={product} />
        </div>
      ))}
    </aside>
  );
};

const getProductIds = (products: ProductPageContent[]) => {
  return products.map((product) =>
    shopifyAdminIdToGraphqlId(product.content.id[0].id),
  );
};
